import { render } from "./FeatureIcon.vue?vue&type=template&id=704048ce&scoped=true"
import script from "./FeatureIcon.vue?vue&type=script&lang=js"
export * from "./FeatureIcon.vue?vue&type=script&lang=js"

import "./FeatureIcon.vue?vue&type=style&index=0&id=704048ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.21_vue@3.5.21_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704048ce"]])

export default __exports__